import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ControlledNumberInput, I18N_NAMESPACES, Label } from '@as/cotopaxi';
import { Box } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
const PDP_QUANTITY_SELECTOR = 'pdp-quantity';
export const ProductQuantityContainer = ({ quantity, setQuantity, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    return (_jsxs(_Fragment, { children: [_jsx(Label, { emphasized: true, htmlFor: PDP_QUANTITY_SELECTOR, children: t('pdp.quantity') }), _jsx(Box, { paddingBlockStart: "2", children: _jsx(ControlledNumberInput, { id: PDP_QUANTITY_SELECTOR, minQuantity: 1, quantity: quantity, onUpdate: setQuantity }) })] }));
};
